<template>
  <div>
    <h4 class="pt-2 pb-3">This reminder will be sent to all users you select. We recommend to set up reminders of offline tasks (e.g.: Test Referral Jam or Send Preview Email, etc.)</h4>
    <advanced-form
      autocomplete="off"
      layout="inline-md-3"
      submit-label="Save"
      :form="formFields"
      v-bind="form"
      v-model="form"
      @submit="input()"
    />
  </div>
</template>

<script>
import AdvancedForm from '@src/components/AdvancedForm';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    AdvancedForm,
  },
  data() {
    const { reminder } = this.value;
    console.log({ reminder });
    delete reminder.__typename;
    return {
      form: {
        to: '',
        sendAt: '',
        description: '',
        status: 'DRAFT',
        ...(reminder || {})
      }
    };
  },
  computed: {
    formFields: () => ({
      to: {
        type: 'STRING',
        label: 'To',
        placeholder: 'mary.doe@company.com,john.doe@company.com,...',
        helpText: 'Enter a list of emails, separated by a comma (CSV).',
        required: true,
      },
      sendAt: {
        label: 'Send Date',
        placeholder: 'dd/mm/yyyy  hh/mm',
        helpText: 'The time when this reminder will be sent, in your timezone',
        type: 'DATETIME',
      },
      description: {
        label: 'Description',
        placeholder: 'Reminder: Don\'t forget...',
        helpText: 'The content of the reminder',
        rows: 6,
        type: 'TEXTAREA',
      },
    }),
  },
  methods: {
    input() {
      const component = { reminder: this.form };
      console.log({ form: this.form });
      console.log('component IS: ', component);
      this.$emit('input', component);
    }
  }
};
</script>

<style lang="scss">
.referral-jam-event-settings {
  .event-logo {
    max-height: 30px;
    max-width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/campaign-admin/update-reminder.vue